import { status } from "skin/event/status";
import { v4 } from "uuid";

// Генерация ключа-допуска для подключения клиента к телеграмм
const genKey = (obj, ms, story, data, d, action) => {
  if (obj.type === "btn") {
    data.setValue("genKey", v4());
    data.setValue(
      "text",
      "Теперь когда ваш ключ сформирован, скопируйте его и нажмите кнопку продолжить, после этого перейдите в telegram, вставьте скопированный ключ, заполните все поля и нажмите кнопку войти. "
    );
    return status.action;
  }
  if (!data.curData.values?.fld?.genKey) {
    return status.ignore;
  } else {
    return status.action;
  }
};
export default genKey;
